import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-monthly-compensates',
    name: 'pay-monthly-compensate',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-monthly-compensate')
  }
]
